<template>
  <div class="ui middle aligned grid" id="anonbg" style="position:absolute; width:100%; margin:0 auto;">

    <div class="mt4 column">
      <div class="ui center">
        <img src="./assets/skwhite_noslogan.png" style="width:350px;display: block; margin-left: auto; margin-right: auto;">
        <!-- <h3 class="ui header center aligned">
          <div class="content">
            <div class="ui fluid card">
              <p>
                Thank you for continuing your subscription.<br>
                We appreciate being able to service your account.<br>
                This confirms that we will apply a 25% discount to your monthly fee for the next 6 months.
              </p>
            </div>
            <button @click="nextButtonPress" class="ui right labeled icon large button setupStep"
              style="margin:auto;display:block;">
              <i class="right arrow icon"></i>
              link to account settings to view subscription
            </button>
            <div class="ui fluid card">
              Check out our most recent blogs if they can provide any help for your Amazon business!
            </div>
          </div>
        </h3> -->
      </div>
      <center>
        <div class="row center">
          <div class="fourteen wide column">
            <div class="ui fluid card" style="padding: 24px; font-size: 24px; max-width: 800px;">
              <!-- <div class="content">
                <div class="header">
                  Thank You!
                </div>
              </div> -->
              <div class="description" style="font-size: 16px;">
                <!-- <hr class="solid"> -->
                Thank you for continuing your subscription.<br>
                We appreciate being able to service your account.<br>

                <div v-if="$root.newPricingMessage !== ''">
                  This confirms that you {{ $root.newPricingMessage }}<br><br>
                </div>

              </div>
              <button @click="nextButtonPress" class="ui right labeled icon large button setupStep"
                      style="margin:auto;display:block;">
                <i class="right arrow icon"></i>
                link to account settings to view subscription
              </button>
            </div> <!-- ./ first card-->



            <div class="ui fluid card" style="padding: 24px; font-size: 24px; max-width: 800px;">
              <div class="description" style="font-size: 16px;">
                Check out our most recent blogs if they can provide any help for your Amazon business!
                <hr class="solid">
              </div>

              <div class="ui fluid container" style="margin-top: 10px;">
                <div class="ui stackable doubling three cards">
                  <a href="https://sentrykit.com/blog/streamline-product-issue-management-how-an-integrated-issue-tracker-simplifies-amazon-asin-management"
                     target="_blank" class="ui card tall segment">
                    <div class="three wide column">
                      <div class="ui image" style="padding: 2%;">
                        <img src="./assets/3.jpg">
                      </div>
                      <div class="content" style="font-size: 16px;padding:5px; border-top: none;">
                        Streamline Product Issue Management: How an Integrated Issue Tracker Simplifies Amazon ASIN Management
                      </div>
                      <div class="description" style="font-size: 16px;padding:5px;color: grey;">
                        Amazon ASINs, or Amazon Standard Identification Numbers, are unique alphanumeric codes assigned to each product listed on the Amazon marketplace. Learn More Here!
                      </div>
                    </div>
                  </a>

                  <a href="https://sentrykit.com/blog/elevate-your-inventory-management-game-a-glance-at-your-total-and-sellable-stock"
                     target="_blank" class="ui card tall segment">
                    <div class="three wide column">
                      <div class="ui image" style="padding: 2%;">
                        <img src="./assets/1.jpg">
                      </div>

                      <div class="content" style="font-size: 16px;padding:5px; border-top: none;">
                        Elevate Your Inventory Management Game: A Glance at Your Total and Sellable Stock
                      </div>
                      <div class="description" style="font-size: 16px;padding:5px;color: grey;">
                        Inventory management is the backbone of a successful e-commerce business, and keeping a close eye on your stock levels is crucial.
                      </div>
                    </div>
                  </a>

                  <a href="https://sentrykit.com/blog/the-ultimate-guide-to-mastering-amazon-ppc-advertising-boost-your-sales-with-effective-search-engine-marketing-strategies"
                     target="_blank" class="ui card tall segment">
                    <div class="three wide column">
                      <div class="ui image" style="padding: 2%;">
                        <img src="./assets/2.jpg">
                      </div>
                      <div class="content" style="font-size: 16px;padding:5px; border-top: none;">
                        The Ultimate Guide to Mastering Amazon PPC Advertising: Boost Your Sales with Effective Search Engine Marketing Strategies
                      </div>
                      <div class="description" style="font-size: 16px;padding:5px;color: grey;">
                        In this ultimate guide, we will delve into the world of Amazon PPC advertising and equip you with the knowledge and techniques needed to master this powerful marketing tool.
                      </div>
                    </div>
                  </a>
                </div><!--./blog div-->
              </div>

            </div> <!-- ./ second card-->
          </div>
        </div>
      </center>
    </div>

    <!-- <div>
    <center>
    <div class="ui three column grid" style="margin-bottom: 24px;">
      <div class="row center">
        <div class="one wide column" />
        <div class="fourteen wide column">

          <div class="ui fluid card" style="padding: 24px; font-size: 24px; max-width: 600px;">
            <div class="content">
              <div class="header">
                Thank You!
              </div>
            </div>
            <div class="description" style="text-align: start; font-size: 16px;">
              <hr class="solid">
              You have successfully set up your <b>SentryKit</b> Account!<br /><br />
              Please check your <b>email</b> for our message and follow the steps to validate your account.<br /><br />
              Once you have validated your email address, we will be able to email you alerts and important messages about
              your account.<br /><br />
              We are now actively linking your SentryKit and Amazon accounts.
            </div>
          </div>
        </div>
        <div class="one wide column" />
      </div>
    </div>
  </center>
  </div> -->
  </div>
</template>
<script>
export default {
  components: {},
  // props: ['discountConfirmed'],
  data: function () {
    return {
      email: '',
      password: '',
      keepMeSignedIn: true,
      error: '',
      working: false,
    }
  },
  methods: {
    nextButtonPress: function () {
      this.$router.push('/settings')
    },
  },
  mounted: function () {
    // alert(this.discountConfirmed)
  },
  created: function () {
    if (window.location.hostname.includes('sentrykit')) {
      window.hj('event', 'new_pricing_redeemed_ev')
    }
  }
}
</script>



// WEBPACK FOOTER //
// NewPricingRedeemedPage.vue?572d983d